<template>
    <div class="lesson-item">
        <div class="lesson-member">
            <el-card shadow="never">
                <el-row class="lesson-member-action">
                    <!-- <el-col :span="12">
                        <el-button size="small" v-for="item in typeList" :key="item.key" :type="item.key == curType ? 'primary' : ''" :plain="curType != item.key"  @click="curType = item.key">
                            {{item.text}}
                        </el-button>
                    </el-col> -->
                    <el-col class="lesson-member-action-right" :offset="12" :span="12" v-if="canEdit">
                        <!-- <el-button type="danger" size="mini" :disabled="!canDo">删除成员</el-button> -->
                        <!-- <el-button type="success" size="mini" :disabled="!canDo">群发私信</el-button> -->
                        <el-button type="success" size="mini" @click="exportExcel">导出成员列表</el-button>
                    </el-col>
                </el-row>
                <el-table class="lesson-member-list" ref="memberTable" tooltip-effect="dark" :data="showList">
                    <!-- 上面的属性  @selection-change="handleSelectionChange" -->
                    <!--  <el-table-column type="selection" v-if="canEdit"></el-table-column> -->
                    <el-table-column label="头像">
                        <template slot-scope="{ row }">
                            <el-avatar class="member-avatar" :src="row.avatar | filterUrl">
                                <img src="~@/assets/imgs/user_icon.png" />
                            </el-avatar>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="username" label="用户名"></el-table-column> -->
                    <el-table-column prop="nickname" label="姓名"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="{ row }">
                            <el-button size="small" type="text" @click="retreat(row)">清退</el-button>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column  label="性别">
                        <template slot-scope="scope">
                            <span>{{scope.row.sex==1?'男':scope.row.sex==2?'女':'未知'}}</span>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column prop="mobile" label="手机"></el-table-column>
                    <el-table-column prop="email" label="邮箱"></el-table-column> -->
                    <!-- <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-s-comment" :title="`私信${scope.row.id}`"></el-button>
              <el-button type="text" icon="el-icon-delete" title="删除"></el-button>
            </template>
          </el-table-column>-->
                </el-table>
                <el-pagination style="margin-top:15px" background prev-text="上一页" next-text="下一页"
                    layout="total, prev, pager, next, jumper" :total="page.total" :current-page="page.page"
                    :page-size="page.limit" @current-change="handlePageChange" hide-on-single-page>
                </el-pagination>
            </el-card>
        </div>
    </div>
</template>

<script>
import { getLessonStudents, getPageCheckStudentList } from "@/api/lab/lesson";
import { retreatUser } from '@/api/lab/lesson2user'
import { exportExcel } from '@/api/common'

export default {
    data () {
        return {
            curType: 2,
            typeList: [{ key: 1, text: "教学团队" }, { key: 2, text: "全部学生" }],
            selectList: [],
            students: [],
            page: {
                page: 1,
                limit: 8,
                total: 0
            }
        };
    },
    props: {
        canEdit: {
            type: Boolean
        }
    },
    filters: {},
    computed: {
        showList () {
            let type = this.curType;
            // 教学团队
            if (type == 1) {
                return [];
            }
            // 学生
            if (type == 2) {
                return this.students;
            }
            return [];
        },
        canDo () {
            return this.selectList.length > 0;
        }
    },
    methods: {
        exportExcel(){  //成员列表的导出
            const { uid } = this.$route.params
            exportExcel('lab/lesson2user', {
                lessonUid: uid
            })
        },
        init () {
            this.getPageCheckStudent()
        },
        // page 改变时会触发
        handlePageChange (page) {
            this.$set(this.page, 'page', page)
            this.getPageCheckStudent()
        },
        handleSelectionChange (selection) {
            this.selectList = selection;
        },
        // 获取课堂下学生列表
        getLessonStudents (lessonUid) {
            this.students = [];
            getLessonStudents(lessonUid).then(res => {
                this.students = res;
            });
        },
        getPageCheckStudent (params = {
            lessonUid: this.$route.params.uid
        }) {
            this.students = [];
            const { page, limit } = this.page
            getPageCheckStudentList(page, limit, params).then(res => {
                const { totalCount } = res
                this.$set(this.page, 'total', totalCount)
                this.students = res.list;
            })
        },
        retreat(row) {
            const { uid } = this.$route.params
            this.$confirm(`清退后，该用户没有该课堂的所有权限，是否确定清退用户${row.nickname}(${row.username})?`, '清退用户', {
                confirmButtonText: '确定',
                cancelButtonTextthi: '取消',
                type: 'warning'
            }).then(() => {
                retreatUser(uid, row.id).then(() => {
                    this.getPageCheckStudent()
                    this.$message.success("操作成功")
                }).catch(() => {})
            }).catch(() => {})
        }
    },
    created () {
        this.init();
    },
    mounted () { }
};
</script>

<style lang="less">
.lesson-member {
    .el-table {
        font-size: 16px;
        th {
            height: 50px;
            text-align: center;
            font-weight: 400;
        }
        td {
            height: 70px;
            text-align: center;
        }
    }
}
</style>

<style lang="less" scoped>
.lesson-member {
    &-action {
        &-right {
            text-align: right;
        }
    }
    &-list {
        .member-avatar {
            width: 36px;
            height: 36px;
        }
    }
}
</style>
